module.exports = __webpack_public_path__ + "static/media/25@2x.16b637ef.png";